$(function () {
  $('[data-toggle="popover"]').popover();
  $('[data-extra="popover"]').popover();
})
